import axios from "axios";
import React, { useEffect, useRef, useState } from "react";

import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import OrderListingComponent from "../../CoreComponents/OrderListingComponent";
import {
  token,
  url,
  is_superuser,
  sees_all_franchises,
  picked_franchise_id,
  protocol,
  has_franchise_reach,
  is_shop_admin,
  is_shop_manager,
} from "../../Functionalities/Config";
import {
  getToken,
  ManageOrders,
  ManageStatus,
  showMessage,
  ManageRestaurant,
  trimFirstAndLastWhiteSpace,
} from "../../Functionalities/Functions";
import FilterComponent from "../../CoreComponents/FilterComponent";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import DayBasisSwitch from "../../CoreComponents/DayBasisSwitch";
import { DAY_PLACED, basisParam, useRefetchOnBasis } from "../../Functionalities/dayBasis";
import { GET_API } from "../../Functionalities/APIs";
import { DEFAULT_CANCEL_WINDOW_MINUTES } from "../../Functionalities/orderBadges";
import {
  REFRESH_INTERVAL_MS,
  freshenCacheBuster,
} from "../../Functionalities/orderListRefresh";

function Body() {
  const [data, setData] = useState({
    id: "",
    name: "",
    order_count: "-",
    data: [],
  });
  const [filter, setfilter] = useState({
    id: "FDR",
    status_id: "",
    from_date: "",
    to_date: "",
    payment_mode: "",
    branch_id: "",
    search_text: "",
    delivery_boy_search: "",
    franchise: picked_franchise_id,
  });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [loading, setLoading] = useState(true);
  const [listLoading, setListLoading] = useState(true);
  const latestRequest = useRef(0);
  const manualInFlight = useRef(false);
  const listUrl = useRef("");
  const [cancelWindowMinutes, setCancelWindowMinutes] = useState(
    DEFAULT_CANCEL_WINDOW_MINUTES
  );
  const [statusArray, setStatusArray] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [basis, setBasis] = useState(DAY_PLACED);
  const [franchise, setFranchise] = useState({ id: "", name: "", data: [] });
  const [restaurant, setRestaurant] = useState({ id: "", name: "", data: [] });

  useEffect(() => {
    getStatus();
    if (is_superuser || has_franchise_reach) {
      getBranches();
    }
    if (is_superuser) {
      getFranchise();
    }
  }, []);

  useEffect(() => {
    getData();
  }, [statusList]);

  useEffect(() => {
    getCancellationWindow();
  }, []);

  const getCancellationWindow = () => {
    const path = is_superuser
      ? "/configurations/admin/?page_wise=0"
      : "/configurations/franchise/?page_wise=0";

    axios({ method: "get", url: url + path, headers: { Authorization: token } })
      .then((response) => {
        const param = (response.data || []).find(
          (p) => p.param_name === "order_cancellation_time_in_minutes"
        );
        const minutes = Number(param?.param_value);
        if (Number.isFinite(minutes) && minutes >= 0) {
          setCancelWindowMinutes(minutes);
        }
      })
      .catch(() => {});
  };

  const getBranches = () => {
    let params = "for_dropdown=true&page_wise=false&order_by_name=true";

    let result = ManageRestaurant("", "", "get", params);
    result
      .then((result) => {
        setRestaurant({
          ...restaurant,
          data: result?.data,
        });
        setLoading(false);
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
      });
  };

  const FranchiseData = async (keyword, params) => {
    let path = "/franchise/details/";
    // let path = "/branch/details/";
    if (keyword == "get") {
      let result = GET_API("", params, path);
      return await result.then((result) => {
        if (result) {
          return result;
        } else {
          return 0;
        }
      });
    }
  };

  const getFranchise = () => {
    let params = "page_wise=false&for_dropdown=true";

    let result = FranchiseData("get", params);
    result
      .then((result) => {
        setFranchise({
          ...franchise,
          data: result.data,
        });
        setLoading(false);
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
      });
  };

  // view=summary returns only the columns this listing renders; opening an order
  // still fetches the full record by id on the OrderID page.
  let params = `view=summary&id=${filter.id.substr(3)}&status_id=${
    filter.status_id
  }&from_date=${filter.from_date}&to_date=${filter.to_date}&payment_mode=${
    filter.payment_mode
  }&status_array=${JSON.stringify(statusList)}&branch_id=${
    filter.branch_id
  }&search_text=${trimFirstAndLastWhiteSpace(
    filter.search_text
  )}&delivery_boy_search=${trimFirstAndLastWhiteSpace(
    filter.delivery_boy_search
  )}&franchise_list=[${filter.franchise}]&scheduled=${
    sessionStorage.getItem("scheduled") === "true" ? "true" : "false"
  }&${
    sessionStorage.getItem("rejected") === "true"
      ? "restaurant_approved_status=declined"
      : sessionStorage.getItem("unattended") === "true"
      ? "restaurant_approved_status=pending"
      : sessionStorage.getItem("pending") === "true"
      ? "restaurant_approved_status=approved"
      : ""
  }${filter.from_date ? basisParam(basis) : ""}`.replace(/^\s+|\s+$/g, "");

  useRefetchOnBasis(basis, () => filter.from_date && getData());

  const showListRows = (response, requestId) => {
    if (requestId !== latestRequest.current) return false;
    setData((prev) => ({
      ...prev,
      data: response.data.results,
      order_count: response.data.count,
    }));
    setNext(response.data.next);
    setPrev(response.data.previous);
    listUrl.current = response.config?.url || "";
    return true;
  };

  const getData = () => {
    const requestId = ++latestRequest.current;
    manualInFlight.current = true;
    setListLoading(true);
    let result = ManageOrders("", "get", "", params);
    result
      .then((result) => {
        if (showListRows(result, requestId)) {
          manualInFlight.current = false;
          setLoading(false);
          setListLoading(false);
        }
      })
      .catch((err) => {
        if (requestId !== latestRequest.current) return;
        manualInFlight.current = false;
        setListLoading(false);
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
      });
  };

  const fetchListUrl = (requestUrl, silent) => {
    const requestId = ++latestRequest.current;
    if (!silent) {
      manualInFlight.current = true;
      setListLoading(true);
    }
    return axios({
      method: "get",
      url: requestUrl,
      headers: { Authorization: getToken() },
    })
      .then((response) => {
        if (showListRows(response, requestId) && !silent) {
          manualInFlight.current = false;
          setListLoading(false);
        }
      })
      .catch(() => {
        if (requestId === latestRequest.current && !silent) {
          manualInFlight.current = false;
          setListLoading(false);
        }
      });
  };

  const refreshCurrentList = () => {
    if (manualInFlight.current || !listUrl.current) return;
    fetchListUrl(freshenCacheBuster(listUrl.current), true);
  };

  const refreshRef = useRef(refreshCurrentList);
  refreshRef.current = refreshCurrentList;

  useEffect(() => {
    const timer = setInterval(() => {
      if (document.visibilityState === "visible") refreshRef.current();
    }, REFRESH_INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  const getStatus = () => {
    let statusRes = ManageStatus("", "get", "", "");
    statusRes.then((result) => setStatusArray(result.data));
  };

  const handleNext = () => {
    fetchListUrl(next.replace("http:", protocol.replace("//", "")), false);
  };

  const handlePrev = () => {
    fetchListUrl(prev.replace("http:", protocol.replace("//", "")), false);
  };

  const ChangeOrderStatus = (statusDetails, index) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            className="custom-ui"
            style={{
              borderRadius: 8,
              border: "solid",
              padding: 70,
              borderWidth: 0.5,
            }}
          >
            <h1>
              Are you sure to {statusDetails.id == 2 ? "accept" : "reject"}?
            </h1>
            <p>Press continue to proceed</p>
            <button
              onClick={onClose}
              className="btn btn-primary"
              style={{ marginRight: 10 }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                ManageOrders("", "patch", statusDetails)
                  .then((res) => {
                    if (res.data.Status === true) {
                      refreshCurrentList();
                      onClose();
                    }
                  })
                  .catch((err) => {});
              }}
              className="btn btn-primary"
            >
              Continue
            </button>
          </div>
        );
      },
    });
  };

  const isOlderThan90Seconds = (date) => {
    if (!date) return false; // Handle null or undefined dates

    const itemTime = new Date(date).getTime();
    const currentTime = Date.now();

    return currentTime - itemTime > 90 * 1000; // 90 seconds in milliseconds
  };

  return (
    <div>
      <div className="content-body">
        {!loading ? (
          <div className="container-fluid">
            <div className="mb-3">
              <DayBasisSwitch value={basis} onChange={setBasis} />
            </div>
            <FilterComponent
              tab={"order"}
              handleNext={handleNext}
              handlePrev={handlePrev}
              next={next}
              prev={prev}
              filterButtonName={"Filter"}
              OrderCount={data?.order_count}
              FilterData={filter}
              functionFilter={(value) => {
                setStatusList([]);
                for (let i = 0; i < value.length; i++) {
                  setStatusList((statusList) => [...statusList, value[i]]);
                }
              }}
            />
            <FilterModalComponent
              heading={"Filter Orders"}
              fromDateValue={filter.from_date.slice(0, 10)}
              fromDateChange={(e) => {
                setfilter({
                  ...filter,
                  from_date: e.target.value + " 00:00:00",
                });
              }}
              toDateValue={filter.to_date.slice(0, 10)}
              toDateChange={(e) => {
                setfilter({
                  ...filter,
                  to_date: e.target.value + " 00:00:00",
                });
              }}
              clearFilter={(e) => {
                e.preventDefault();
                window.location.reload();
                localStorage.removeItem("order_filter");
                setfilter({
                  ...filter,
                  id: "FDR",
                  status_id: "",
                  from_date: "",
                  to_date: "",
                  payment_mode: "",
                  branch_id: "",
                  search_text: "",
                  delivery_boy_search: "",
                  franchise: picked_franchise_id,
                });
              }}
              submitFilter={(e) => {
                e.preventDefault();
                getData();
                localStorage.setItem("order_filter", JSON.stringify(filter));
              }}
            >
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Order ID <span className="required"></span>
                  </label>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      placeholder="Order Id"
                      value={filter.id}
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          id: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Status <span className="required"></span>
                  </label>
                  <div className="form-group">
                    <select
                      value={filter.status_id}
                      class="form-control form-control-lg  "
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          status_id: e.target.value,
                        })
                      }
                    >
                      <option value={""} id={""}>
                        All
                      </option>

                      {statusArray &&
                        statusArray.length &&
                        statusArray.map((item) => (
                          <option value={item.id} id={item.id}>
                            {item.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>

              {sees_all_franchises && (
                <div className="col-lg-12">
                  <div className="form-group">
                    <label className="text-black font-w600">
                      Franchise <span className="required"></span>
                    </label>
                    <div className="form-group">
                      <select
                        value={filter.franchise}
                        class="form-control form-control-lg  "
                        onChange={(e) =>
                          setfilter({ ...filter, franchise: e.target.value })
                        }
                      >
                        <option value={""} id={""}>
                          All
                        </option>
                        {franchise.data.map((franchise) => (
                          <option value={franchise.id} id={franchise.id}>
                            {franchise.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              )}

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Payment Mode <span className="required"></span>
                  </label>
                  <div className="form-group">
                    <select
                      value={filter.payment_mode}
                      class="form-control form-control-lg  "
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          payment_mode: e.target.value,
                        })
                      }
                    >
                      <option value={""} id={""}>
                        All
                      </option>
                      <option value={"COD"} id={"COD"}>
                        Cash On Delivery
                      </option>
                      <option value={"ONLINE"} id={"ONLINE"}>
                        Online Payment
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              {(is_superuser || has_franchise_reach) && (
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="text-black font-w600">
                      Restaurant <span className="required"></span>
                    </label>
                    <select
                      value={filter.branch_id}
                      class="form-control form-control-lg"
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          branch_id: e.target.value,
                        })
                      }
                    >
                      <option value={""} id={""}>
                        All
                      </option>
                      {restaurant?.data.map((item) => (
                        <option value={item.id} id={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Search User <span className="required"></span>
                  </label>
                  <div className="form-group">
                    <input
                      className="form-control"
                      value={filter.search_text}
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          search_text: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Search Deliveryboy <span className="required"></span>
                  </label>
                  <div className="form-group">
                    <input
                      className="form-control"
                      value={filter.delivery_boy_search}
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          delivery_boy_search: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </FilterModalComponent>

            <div className="row mt=2">
              <div className="col-lg-12">
                <div className="table-responsive rounded card-table">
                  <div
                    id="example5_wrapper"
                    class="dataTables_wrapper no-footer"
                  >
                    <table
                      className="table border-no order-table mb-4 table-responsive-lg dataTablesCard"
                      id="example5"
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "8rem" }}>ID</th>
                          <th>STATUS</th>

                          {(is_superuser || has_franchise_reach) && (
                            <th>CUSTOMER</th>
                          )}
                          <th>DELIVERY BOY</th>
                          {(is_superuser ? (
                            <th>FRANCHISE</th>
                          ) : (
                            has_franchise_reach
                          )) && <th>RESTAURANT </th>}
                          {(is_superuser || has_franchise_reach) && (
                            <th>AMOUNT</th>
                          )}
                          {(sessionStorage.getItem("unattended") === "true" ||
                            sessionStorage.getItem("rejected") === "true") &&
                            has_franchise_reach && <th>REST STATUS</th>}
                        </tr>
                      </thead>

                      {!listLoading &&
                        data.data.length > 0 &&
                        data.data.map((item, index) => {
                          return (
                            <tbody key={item.id}>
                              {is_superuser === true ? (
                                <OrderListingComponent
                                  item={item}
                                  cutomerName={false}
                                  cancelWindowMinutes={cancelWindowMinutes}
                                  onRestaurantStatusChange={refreshCurrentList}
                                />
                              ) : (
                                <>
                                  {((sessionStorage.getItem("unattended") ===
                                    "true" &&
                                    isOlderThan90Seconds(item?.date)) ||
                                    sessionStorage.getItem("unattended") ===
                                      "false") && (
                                    <OrderListingComponent
                                      item={item}
                                      cutomerName={false}
                                      cancelWindowMinutes={cancelWindowMinutes}
                                      onRestaurantStatusChange={refreshCurrentList}
                                      accept={() =>
                                        ChangeOrderStatus(
                                          {
                                            id: "2",
                                            orderid: item.id,
                                            desc: "",
                                            keyword: "change_status",
                                          },
                                          item.index
                                        )
                                      }
                                      reject={() =>
                                        ChangeOrderStatus(
                                          {
                                            id: "3",
                                            orderid: item.id,
                                            desc: "",
                                            keyword: "change_status",
                                          },
                                          item.index
                                        )
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </tbody>
                          );
                        })}
                    </table>
                    <FilterComponent
                      handleNext={handleNext}
                      handlePrev={handlePrev}
                      next={next}
                      prev={prev}
                    />
                    <div className="d-flex justify-content-center">
                      {listLoading && <h5>Loading orders...</h5>}
                      {loading === false && !listLoading && (
                        <>{data.data.length <= 0 && <h5>No Orders found</h5>}</>
                      )}
                    </div>

                    {/* <div class="dataTables_info" id="example5_info" role="status" aria-live="polite">Showing 1 to 10 of 11 entries</div> */}
                    <div
                      class="dataTables_paginate paging_simple_numbers"
                      id="example5_paginate"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            {" "}
            <LoadingComponent />
          </>
        )}
      </div>
    </div>
  );
}

function Orders() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={"Orders"} subHeading={"All Orders under foodoor"} />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Orders;
